module.exports = __webpack_public_path__ + "img/ARVO2026.b5f92cb4.png";